import _ from 'lodash';
import error from 'aurora-utils/error';
import * as types from './constants';

const defaultState = {
  loading: false,
  application: null,
  error,
  applicationAction: null,
  dmtLocation: null,
  slots: null,
  appointBookied: false,
  cancelError: error,
  workflowHistory: [],
  loadingTitleDeed: false,
};

export default function applicationReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.FETCH_APPLICATION:
      return {
        ...state,
        loading: true,
      };
    case types.FETCH_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: _.get(action.payload, 'application'),
        applicationAction: _.get(action.payload, 'application.applicationAction'),
        error,
      };
    case types.FETCH_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: _.get(action.payload, 'error'),
      };
    // DMT LOCATION
    case types.FETCH_LOCATION:
      return {
        ...state,
        query: _.get(action.payload, 'query'),
        loading: true,
      };
    case types.FETCH_LOCATION_SUCCESS:
      return {
        ...state,
        loading: false,
        dmtLocation: _.get(action.payload, 'locations'),
        error,
      };
    case types.FETCH_LOCATION_ERROR:
      return {
        ...state,
        loading: false,
        dmtLocation: null,
        error: _.get(action.payload, 'error'),
      };
    // DMT Slots
    case types.FETCH_SLOT:
      return {
        ...state,
        query: _.get(action.payload, 'query'),
        loading: true,
      };
    case types.FETCH_SLOT_SUCCESS:
      return {
        ...state,
        loading: false,
        slots: _.get(action.payload, 'slots'),
        error,
      };
    case types.FETCH_SLOT_ERROR:
      return {
        ...state,
        loading: false,
        slots: null,
        error: _.get(action.payload, 'error'),
      };
    // DMT bOOKING
    case types.BOOKING_APPOINTMENT:
      return {
        ...state,
        query: _.get(action.payload, 'query'),
        loading: true,
      };
    case types.BOOKING_APPOINTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        appointBookied: _.get(action.payload, 'appointment'),
        error,
      };
    case types.BOOKING_APPOINTMENT_ERROR:
      return {
        ...state,
        loading: false,
        appointBookied: false,
        error: _.get(action.payload, 'error'),
      };
    case types.FETCH_SELL_WORKFLOW_HISTORY:
      return {
        ...state,
        workflowHistory: [],
        error: null,
      };
    case types.FETCH_SELL_WORKFLOW_HISTORY_SUCCESS:
      return {
        ...state,
        workflowHistory: _.get(action.payload, 'workflowHistory'),
      };
    case types.SELL_CANCEL_APPLICATION:
      return {
        ...state,
        loading: true,
      };
    case types.SELL_CANCEL_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        cancelError: null,
      };
    case types.SELL_CANCEL_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        cancelError: _.get(action.payload, 'error'),
      };
    case types.SELL_DOWNLOAD_TITLE_DEED:
      return {
        ...state,
        loadingTitleDeed: true,
      };
    case types.SELL_DOWNLOAD_TITLE_DEED_SUCCESS:
      return {
        ...state,
        loadingTitleDeed: false,
        error: null,
      };
    case types.SELL_DOWNLOAD_TITLE_DEED_ERROR:
      return {
        ...state,
        loadingTitleDeed: false,
        error: _.get(action.payload, 'error'),
      };
    default:
      return state;
  }
}
